import React from "react";
import _ from "lodash";
import cx from "classnames";
import s from "./simpleSelect.scss";

export default class SimpleSelect extends React.Component {
  constructor(props) {
    super(props);
    this.updateValue = this.updateValue.bind(this);
    this.state = {
      initialOptions: props.options.map(obj => (
        <option value={obj.value} disabled={obj.disabled} key={`${obj.value}${obj.label}`}>
          {obj.label}
        </option>
      ))
    };
  }
  updateValue(e) {
    e.preventDefault();
    this.props.onChange({ [this.props.name]: e.currentTarget.value });
  }

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.value === this.props.value &&
      nextProps.disabled === this.props.disabled &&
      _.isEqual(this.props.errors, nextProps.errors)
    ) {
      return false;
    }

    return true;
  }

  render() {
    const {
      className,
      label,
      labelinrow,
      hint,
      required,
      disabled,
      errors,
      name,
      // noLabel,
      options,
      value,
      immutableOptions
    } = this.props;
    // if options are declared as immutable, use the ones
    // passed on the first render. Do not use this if options
    // can be disabled dinamically
    let opts;
    if (!immutableOptions) {
      opts = options.map(obj => (
        <option value={obj.value} disabled={obj.disabled} key={`${obj.value}${obj.label}`}>
          {obj.label}
        </option>
      ));
    } else {
      opts = this.state.initialOptions;
    }

    return (
      <div
        className={cx(className, s.selectContainer, {
          [s.required]: required,
          [s.labelinrow]: labelinrow,
          [s.labelHint]: hint,
          [s.disabled]: disabled,
          [s.withErrors]: errors
        })}
      >
        {(label || hint) && (
          <div className={s.wrapLabel}>
            <label className={s.label} htmlFor={name}>
              {label || name.replace("_", " ")}
            </label>
            {hint && <div className={s.hint}>{hint}</div>}
          </div>
        )}

        <div className={s.wrapSelect}>
          <select
            className={s.select}
            disabled={disabled}
            onChange={this.updateValue}
            required={required}
            value={value}
            name={name}
          >
            {opts}
          </select>
        </div>

        {errors && <div className={s.errorMsg}>{errors}</div>}
      </div>
    );
  }
}
